import React, { useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Box, Tooltip, IconButton, TablePagination } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

const MwcTable = ({ mwcUnits, onEdit, onDelete }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const paginatedMwc = mwcUnits.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  return (
    <Box sx={{ overflowX: 'auto' }}>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="mwc table">
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Nama MWC</TableCell>
              <TableCell>Alamat</TableCell>
              <TableCell align="center">Pengguna Terkait</TableCell>
              <TableCell align="center">Ranting Terkait</TableCell>
              <TableCell align="center">Aksi</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedMwc.length === 0 ? (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  Belum ada data MWC.
                </TableCell>
              </TableRow>
            ) : (
              paginatedMwc.map((mwc) => (
                <TableRow key={mwc.id}>
                  <TableCell>{mwc.id}</TableCell>
                  <TableCell>{mwc.name}</TableCell>
                  <TableCell>{mwc.address || '-'}</TableCell>
                  <TableCell align="center">{mwc._count?.users || 0}</TableCell>
                  <TableCell align="center">{mwc._count?.rantings || 0}</TableCell>
                  <TableCell align="center">
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                      <Tooltip title="Edit MWC">
                        <IconButton onClick={() => onEdit(mwc)} color="primary">
                          <EditIcon />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Hapus MWC">
                        <IconButton onClick={() => onDelete(mwc.id)} color="error">
                          <DeleteIcon />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={mwcUnits.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </TableContainer>
    </Box>
  );
};

export default MwcTable;
